export const isValidCart = (cart) =>
  Array.isArray(cart) && cart.length > 0 && cart.every(({ id } = {}) => typeof id === 'string' && id.trim() !== '');
